import { render } from "./App.vue?vue&type=template&id=5b8d67ca&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5b8d67ca&scoped=true&lang=css"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8d67ca"]])

export default __exports__